import React, { useEffect, useState } from 'react';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SensorDataItem from './SensorDataItem';
import {
  SensorAlertParam,
  SensorLatest,
  SensorWiFiConfOptionsAnalysisTypeEnum,
  VarName,
} from '../../../services/api';
import useStyles from '../../../styles';
import { getSensorAlertConfig } from '../../../services/apiService';
import AlertConfig from '../../../Views/AlertConfig';
import { ChecklistType } from '../../AlertConfig/helpers';
import { useAppDispatch } from '../../../state/store';
import { setAlertsById } from '../../../state/actions';

interface SensorDataProps {
  sensorDetails: SensorLatest | undefined;
}

function SensorData({ sensorDetails }: SensorDataProps): JSX.Element {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const [alertParams, setAlertParams] = useState<SensorAlertParam[]>([]);

  const sensorId = sensorDetails?.id ?? '';
  const onlineStatusValue = sensorDetails?.data?.find(
    (d) => d.varName === VarName.OnlineStatus
  )?.value;

  useEffect(() => {
    getSensorAlertConfig(sensorId)
      .then((res) => {
        if (res.alerts.length > 0) {
          dispatch(setAlertsById([res]));
          setAlertParams(res.alerts);
        } else setAlertParams([]);
      })
      .catch(() => null);
  }, [dispatch, sensorId]);

  return (
    <Grid size={{ sm: 6, xs: 12 }}>
      <Paper elevation={0}>
        <List>
          <ListItem>
            <AssessmentIcon className={classes.icon} style={{ alignSelf: 'center' }} />
            <Typography variant="h6" style={{ marginLeft: '10px' }}>
              Sensor Data
            </Typography>
          </ListItem>
          <Divider />
          {sensorDetails?.data?.map((item) => (
            <Box key={item.varName}>
              <SensorDataItem
                sensorId={sensorDetails.id}
                dataItem={item}
                isOnline={onlineStatusValue !== undefined && onlineStatusValue > 0}
                alertParam={alertParams.find((alertItem) => {
                  const { analysisOptions } = alertItem;
                  const { analysisType } = analysisOptions;

                  const isWifiConf =
                    analysisType === SensorWiFiConfOptionsAnalysisTypeEnum.SensorWiFiConf;
                  const varName = !isWifiConf ? analysisOptions.varName : VarName.ClientsWiFi;

                  return varName === item.varName;
                })}
              />
            </Box>
          ))}
        </List>
      </Paper>

      <Box sx={{ mt: '8px' }}>
        <AlertConfig
          checkListId={sensorId}
          checklistType={ChecklistType.sensor}
          params={alertParams}
          setParams={(value) => setAlertParams(value as SensorAlertParam[])}
        />
      </Box>
    </Grid>
  );
}

export default SensorData;
